import { render, staticRenderFns } from "./my-feedback.vue?vue&type=template&id=7bcc723c&scoped=true&"
import script from "./my-feedback.vue?vue&type=script&lang=js&"
export * from "./my-feedback.vue?vue&type=script&lang=js&"
import style0 from "./my-feedback.vue?vue&type=style&index=0&id=7bcc723c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcc723c",
  null
  
)

export default component.exports